import React, { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import ClientsTable from './ClientsTable/ClientsTable';
import { publicHash } from '../../utils/constants';
import ArrowButton from '../../components/_atomic/ArrowButton/ArrowButton';

class ClientsScreen extends Component {
  static propTypes = {
    getAllUsersFull: PropTypes.func.isRequired,
    usersFull: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    usersFullStatus: PropTypes.string.isRequired,
    //   pageUsersFull: PropTypes.number.isRequired,
    hasMoreUsersFull: PropTypes.number.isRequired,
    deleteUser: PropTypes.func.isRequired,
    sidebarStatus: PropTypes.bool,
    history: PropTypes
      .shape({
        push: PropTypes.func.isRequired,
      })
      .isRequired,
  };
  static defaultProps = {
    sidebarStatus: true,
  }
  state = {};

  componentWillMount() {}
  componentDidUpdate() {}
  navigateToUserLogs = (id) => {
    this.props.history.push(`${publicHash}/app/client/${id}/logs`);
  }
  navigateToUserProfile = (id) => {
    this.props.history.push(`${publicHash}/app/client/${id}/profile`);
  }
  navigateToBack = () => {
    window.history.back();
  }
  render() {
    const clientsScreenClasses = classNames({
      screen: true,
      'clients-screen': true,
    });
    const {
      getAllUsersFull,
      usersFull,
      usersFullStatus,
      hasMoreUsersFull,
      deleteUser,
      sidebarStatus,
    } = this.props;
    return (
      <div className={clientsScreenClasses}>
        <div className="main-label-no-transform">
          <ArrowButton onClick={this.navigateToBack} padLeft={sidebarStatus ? 125 : 125} />
          <span>Clients</span>
        </div>
        <ClientsTable
          getAllUsersFull={getAllUsersFull}
          hasMoreUsersFull={hasMoreUsersFull}
          usersFullStatus={usersFullStatus}
          deleteUser={deleteUser}
          usersFull={usersFull}
          navigateToLogs={this.navigateToUserLogs}
          navigateToProfile={this.navigateToUserProfile}
        />
      </div>
    );
  }
}

export default ClientsScreen;



// WEBPACK FOOTER //
// ./src/containers/ClientsScreen/ClientsScreen.js